import { isConfigReport, isCustomWidgetReport, isHistoricalReport, isJourneyReport } from 'reporting-data/tsTypes/reportTypes';
import { getMetricProperties as getConfigReportMetricProperties, isTimeSeriesReport } from 'reporting-data/report/configReportGetters';
import { deriveDataTypeFamiliesFromDataSources } from '../categorizationUtils/dataTypeFamilyDerivationUtils';
export const isHardToReproReport = report => {
  if (isConfigReport(report)) {
    const metricProperties = getConfigReportMetricProperties(report);
    const hasUnusualMetric = metricProperties.some(property => ['dealstages.*_duration', 'ticketstages.*_duration'].includes(property) || property.includes('raas_'));
    return isCustomWidgetReport(report) || hasUnusualMetric || isHistoricalReport(report);
  }
  const dataSources = deriveDataTypeFamiliesFromDataSources(report);
  return isJourneyReport(report) || dataSources.length > 1;
};
export const getIsTimeSeriesReport = report => isConfigReport(report) && isTimeSeriesReport(report);